export const SORT_LABELS = {
  BY_LATEST: 'Mais recentes',
  BY_MOST_LIKED: 'Mais curtidas',
  BY_MOST_COMMENTED: 'Mais comentadas',
};

export const SORT_VALUES = {
  LATEST: 'latest',
  MOST_LIKED: 'likes',
  MOST_COMMENTED: 'comments',
};

export const LEGACY_SORT_OPTIONS = {
  comments: SORT_VALUES.MOST_COMMENTED,
  newest: SORT_VALUES.LATEST,
  relevance: SORT_VALUES.MOST_LIKED,
};
